var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 15.125C13.2782 15.125 15.125 13.2782 15.125 11C15.125 8.72183 13.2782 6.875 11 6.875C8.72183 6.875 6.875 8.72183 6.875 11C6.875 13.2782 8.72183 15.125 11 15.125Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.966 6.93096C17.1693 7.22951 17.35 7.54292 17.5063 7.86854L19.7361 9.10633C20.0077 10.3537 20.0086 11.6448 19.7388 12.8925L17.5078 14.131C17.3509 14.4564 17.1698 14.7695 16.966 15.0677L17.0089 17.6177C16.0645 18.4765 14.9468 19.1229 13.7314 19.5131L11.5433 18.2003C11.1831 18.2271 10.8214 18.2268 10.4612 18.1994L8.27434 19.5115C7.0583 19.1231 5.93971 18.4783 4.99402 17.6208L5.03696 15.0695C4.83363 14.7709 4.65301 14.4575 4.49664 14.1319L2.26689 12.8941C1.9953 11.6467 1.99436 10.3557 2.26415 9.1079L4.49514 7.86943C4.65203 7.54405 4.83314 7.23093 5.03695 6.9327L4.99403 4.38278C5.93848 3.5239 7.05614 2.87754 8.27161 2.4873L10.4597 3.80017C10.8199 3.77335 11.1816 3.77363 11.5418 3.80102L13.7286 2.48889C14.9447 2.87736 16.0633 3.5221 17.009 4.37962L16.966 6.93096Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4a7974ec.svg";
export { ForwardRef as ReactComponent };